import React from "react";
import { Avatar, Box, Typography } from "@material-ui/core";
import { CustomCard, SocialLinks } from "../../../../../Components";
import { getDownloadableLink } from "../../../../../Helper";
import { useTranslate } from "../../../../../Hooks";

import useStyles from "./styles";

import { VerifiedIcon } from "../../../../../assets/icons";

function AgentCard({ contact: details }) {
  const styles = useStyles();
  const { translate } = useTranslate("AfterSalesClientProfileView");
  return (
    <CustomCard classes={styles.agentCard}>
      <Box className={styles.contactDetailsContainer}>
        <Box className={styles.avatarWrapper}>
          <Avatar
            className={
              details?.imagePath ? styles.avatar : styles.defaultAvatar
            }
            src={
              details?.profileImg
                ? getDownloadableLink(details?.profileImg)
                : details?.contact_type_id === 2 // "CORPORATE"
                ? "/images/contacts/CorporateAvatar.svg"
                : details?.gender?.lookupItemName === "Male"
                ? "/images/contacts/MaleAvatar.svg"
                : "/images/contacts/FemaleAvatar.svg"
            }
          />
          <VerifiedIcon
            width={18}
            height={18}
            className={styles.verifiedIcon}
          />
        </Box>
        <Box className={styles.contactDetails}>
          <Typography variant="h6">{details?.fullName}</Typography>
          <Typography variant="body2" component="p">
            {translate("assigned-agent")}
          </Typography>
        </Box>
      </Box>
      <Typography variant="body2" component="p">
        {details?.languages
          ?.map((lang) => lang.lookupItemName)
          .join(", ")}
      </Typography>
      {/* <SocialLinks activeItem={{}} gap={8} /> */}
    </CustomCard>
  );
}

export default AgentCard;
